import React from 'react';


const SpecificationsPage = () => {
  return (
    <div className="App">

      <section className="section specs-section">
        <div className="container">
          <div className="section-title">
            <h2>Complete Product Specifications</h2>
            <p>Detailed technical information about the Nozomi Robotics kit</p>
          </div>

          <div className="specs-container">
            <div className="spec-category">
              <h3>Physical Specifications</h3>
              <table className="spec-table">
                <tbody>
                  <tr>
                    <td className="spec-name">Dimensions</td>
                    <td className="spec-value">15cm × 12cm × 8cm</td>
                  </tr>
                  <tr>
                    <td className="spec-name">Weight</td>
                    <td className="spec-value">250g (with batteries)</td>
                  </tr>
                  <tr>
                    <td className="spec-name">Material</td>
                    <td className="spec-value">PLA (3D printed chassis)</td>
                  </tr>
                  <tr>
                    <td className="spec-name">Construction</td>
                    <td className="spec-value">Snap-together design with minimal screws</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="spec-category">
              <h3>Electronics</h3>
              <table className="spec-table">
                <tbody>
                  <tr>
                    <td className="spec-name">Microcontroller</td>
                    <td className="spec-value">Micro:Bit</td>
                  </tr>
                  <tr>
                    <td className="spec-name">Motors</td>
                    <td className="spec-value">2× SG90 Servo Motors (360° rotation)</td>
                  </tr>
                  <tr>
                    <td className="spec-name">Power</td>
                    <td className="spec-value">3× AA Batteries (not included)</td>
                  </tr>
                  <tr>
                    <td className="spec-name">Battery Life</td>
                    <td className="spec-value">Approximately 8 hours of active use</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="spec-category">
              <h3>Software</h3>
              <table className="spec-table">
                <tbody>
                  <tr>
                    <td className="spec-name">Programming Interface</td>
                    <td className="spec-value">Custom Block-based visual programming</td>
                  </tr>
                  <tr>
                    <td className="spec-name">Application Type</td>
                    <td className="spec-value">Electron desktop application</td>
                  </tr>
                  <tr>
                    <td className="spec-name">Compatible OS</td>
                    <td className="spec-value">Windows 10+, macOS 11+</td>
                  </tr>
                  <tr>
                    <td className="spec-name">Connectivity</td>
                    <td className="spec-value">USB wired connection</td>
                  </tr>
                  <tr>
                    <td className="spec-name">Updates</td>
                    <td className="spec-value">Automatic updates</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="spec-category">
              <h3>Educational Content</h3>
              <table className="spec-table">
                <tbody>
                  <tr>
                    <td className="spec-name">Target Age</td>
                    <td className="spec-value">10+ years</td>
                  </tr>
                  <tr>
                    <td className="spec-name">Skill Level</td>
                    <td className="spec-value">Beginner to Intermediate</td>
                  </tr>
                  <tr>
                    <td className="spec-name">Curriculum</td>
                    <td className="spec-value">15+ challenges and activities</td>
                  </tr>
                  <tr>
                    <td className="spec-name">Learning Outcomes</td>
                    <td className="spec-value">Problem decomposition, pattern recognition, algorithmic thinking, abstraction</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="spec-category">
              <h3>Package Contents</h3>
              <table className="spec-table">
                <tbody>
                  <tr>
                    <td className="spec-name">3D Printed Parts</td>
                    <td className="spec-value">Chassis body, wheels, servo mounts, ultrasonic sensor mount</td>
                  </tr>
                  <tr>
                    <td className="spec-name">Electronics</td>
                    <td className="spec-value">1× Micro:Bit, 2× SG90 Servo Motors, 1× battery holder, 1x PCB, 1x Ultrasonic Sensor, 1x Ribbon cable, 1x Switch</td>
                  </tr>
                  <tr>
                    <td className="spec-name">Mechanical Components</td>
                    <td className="spec-value">2× wheels, 1× training wheel, mounting hardware</td>
                  </tr>
                  <tr>
                    <td className="spec-name">Documentation</td>
                    <td className="spec-value">Assembly video guide</td>
                  </tr>
                  <tr>
                    <td className="spec-name">Connectivity</td>
                    <td className="spec-value">1× Micro USB cable</td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* <div className="spec-category">
              <h3>Support & Warranty</h3>
              <table className="spec-table">
                <tbody>
                  <tr>
                    <td className="spec-name">Technical Support</td>
                    <td className="spec-value">Email</td>
                  </tr>
                  <tr>
                    <td className="spec-name">Replacement Parts</td>
                    <td className="spec-value">Available for purchase individually</td>
                  </tr>
                  <tr>
                    <td className="spec-name">Educator Support</td>
                    <td className="spec-value">Classroom implementation guides and lesson plans available</td>
                  </tr>
                </tbody>
              </table>
            </div> */}
          </div>
        </div>
      </section>

    </div>
  );
};

export default SpecificationsPage;